<template>
<div style="position: relative;">
    <div :class="$style.selectReport">  
       <!--  <button @click="add_report" style="position:absolute;top:-10px;left:0px;padding: 5px 10px;">{{ 'new_report' | str}}</button> -->
        <input type="text" v-model="report_search" :placeholder="label('search_reports')"><br>
        <div :class="$style.scrollTable">
        <table>
        <tr v-for="report in filtered_reports" :key="report.id">
        <td>
        <input type=radio :id="report.id" @change="OnRadioChange()" :value="report" v-model="report_record">
        <label :for="report.id" :class="$style.report_code"> {{report.code}} </label>
        <label :for="report.id" :class="$style.report_name"> {{objLabel(report,'name')}} </label>
        </td>
        </tr>
        </table>
        </div>
    </div>

    <div :class="[$style.main, $style.formContent]">
    <!--{{report}}-->
        <template v-if="report">

            <transition name='fade'>
            <button v-if="valid_report" @click="saveReport" class="themed" style="position: absolute; right: 0; padding: 5px 10px; top:5px;">
                <i class="fa fa-save"></i> 
                {{'save'|str}}
            </button>                         
            </transition>
            <br>
             <div v-if="!new_report" :class="$style.formItem"  style="position: absolute; right: 0; padding: 5px 10px; top:20px;">
                <div :class="$style.main_label"> {{ 'lastUpdatedBy' | str}}:</div>
                &nbsp;
                <label>
                    {{report.updated_at | prettify_date}}
                </label>
            </div>
            <br>
            <div :class="$style.formItem" >
                <div :class="$style.main_label">{{'code' | str}}:</div> 
                &nbsp;
                <input  v-if="new_report" type="text" v-model="report.code">
                <template v-else> 
                    {{report.code}} 
                </template>
            </div>

            <div :class="$style.formItem" >
                <div :class="$style.main_label">{{'report_name_en' | str}}:</div> 
                &nbsp;
                <input type="text" v-model="report.name">       
            </div>

            <div :class="$style.formItem">
                <div :class="$style.main_label"> {{ 'category' | str}} :</div>
                &nbsp;
                <select @change="onReportCategoryChange($event)">
                    <option :selected="report.report_type_id === 0"></option>
                    <option v-for="item in list_report_categories" :key="item.id" :value="item.id" :selected="item.id === get_report_category_id">
                        {{objLabel(item, 'name')}} 
                    </option>
                </select> 
            </div>
            
             <div :class="$style.formItem">
                <div :class="$style.main_label"> {{ 'report_type' | str}} :</div>
                &nbsp;
                <select @change="onReportTypeChange($event)">
                    <option :selected="report.report_type_id === 0"></option>
                    <option v-for="item in list_report_types" :key="item.id" :value="item.id" :selected="item.id === report.report_type_id">
                        {{objLabel(item, 'name')}} 
                    </option>
                </select> 
            </div>
                        
            <div :class="$style.formItem">
                <div :class="$style.main_label"> {{ 'report_generated_by' | str}} :</div>
                &nbsp;
                <select v-model="report.source">
                    <option></option>
                    <option v-for="item in list_sources" :key="item">
                        {{item}} 
                    </option>
                </select> 
            </div>
            
            <div :class="$style.formItem">
                <div :class="$style.main_label"> {{ 'report_frequency' | str}}:</div>
                &nbsp;
                <select @change="onReportFrequencyChange($event)">
                    <option :selected="report.report_frequency_id === 0"></option>
                    <option v-for="item in list_report_frequencies" :key="item.id" :value="item.id" :selected="item.id === report.report_frequency_id">
                        {{objLabel(item, 'name')}} 
                    </option>
                </select> 
            </div>
            <br>
            <fieldset>
            <legend :class="$style.formItem">
                    <div :class="$style.main_label"> {{ 'retention_policy' | str }} </div>
            </legend>
            <div :class="$style.formItem" >
                <div :class="$style.main_label">{{'retention' | str}}:</div> 
                &nbsp;
                <input type="number" v-model.number="report.retentionPeriod">
                &nbsp;      
                <div :class="$style.main_label">{{'days' | str}}</div> 
            </div>
            </fieldset>

            <fieldset>
            <div :class="$style.formItem" >
                <div :class="$style.main_label">{{'brand' | str}}:</div> 
                &nbsp;
                <template v-for="brand in list_brands">
                    <label :key="'brand_'+brand.id" :class="['box_radio', {'primary':report.brand_id==brand.id}]">
                        <input type="radio" :value="brand.id" @click="onBrandChange($event)"> 
                        {{brand.name}} 
                    </label>
                    
                </template>    
                
            </div>

            <div :class="$style.formItem">
                <div :class="$style.main_label"> {{ 'hasFrench' | str}}:</div>
                &nbsp;
                <label>
                    <input type='checkbox' v-model='report.has_french' >
                </label>
            </div>
            <div :class="$style.formItem">
                <div :class="$style.main_label"> {{ 'report_name_fr' | str}}:</div>
                &nbsp;
                <label>
                    <input type='text' v-model='report.name_fr' >
                </label>
            </div>
            <div :class="$style.formItem">
                <div :class="$style.main_label"> {{ 'overwriteReport' | str}}:</div>
                &nbsp;
                <label>
                    <input type='checkbox' v-model='report.overwritten' >
                </label>
            </div>
            <div :class="$style.formItem">
                <div :class="$style.main_label"> {{ 'multiplePerDay' | str}}:</div>
                &nbsp;
                <label>
                    <input type='checkbox' v-model='report.multiplePerDate' >
                </label>
            </div>
            </fieldset>
            <!--
            <div style="position: absolute; right: 0; bottom: 0;">
            <transition name='fade'>
            <button v-if="valid_report" @click="saveReport" class="themed" style="float: right; padding: 5px 10px; margin-left: 10px; ">
                <i class="fa fa-save"></i> 
                {{'save'|str}}
            </button>
            </transition>
            <br> 
            <div v-if="!new_report" :class="$style.formItem" style="">
                <div :class="$style.main_label"> {{ 'lastUpdatedBy' | str}}:</div>
                &nbsp;
                <label>
                    {{report.updated_at | prettify_date}}
                </label>
            </div>
            </div>
            -->
             <!-- Commenting out for future use
            <transition name='fade'>
            <button v-if="!new_report" @click="deleteReport" style="padding: 5px 10px; margin-left: 10px;"> 
                {{'delete_report'|str}}
            </button>
            </transition> -->   
        </template>
    </div>
</div>
</template>

<script>
export default {
    name: 'reportManagement',
    props: {
        adminData: {
            type: Object,
            required: true
        }
    },
    data: function(){
        return {
            new_report: false,
            report_search: null,
            report_record: null,
            report_category: 0,
            report: null,
            filtered_reports: [],
            timer: null,
            list_sources: ["Toyota University", "BI", "Vendors", "IBU", "S4", "POLK"]
        }
    },
    methods: {
        onBrandChange: function(event){
            this.report.brand_id=parseInt(event.target.value);
        },       
        onReportTypeChange: function(event){
            this.report.report_type_id=parseInt(event.target.value);
        },
        onReportCategoryChange: function(event){
            this.report_category=parseInt(event.target.value);          
        },
        onReportFrequencyChange: function(event){
            this.report.report_frequency_id=parseInt(event.target.value);           
        },
        OnRadioChange: function(){
            this.report_category  = 0;           
        },
         add_report: function(){
            this.new_report = true;
            this.report = template();
            this.report_record = null;
            this.report_search = null;

            function template(){
                return {
                    "id": null, 
                    "name": null, 
                    "name_fr": null, 
                    "code": null, 
                    "source": null, 
                    "has_french": false, 
                    "overwritten": false, 
                    "multiplePerDate": false, 
                    "retentionPeriod": 0, 
                    "report_type_id": 0, 
                    "report_frequency_id": 0, 
                    "created_at": null, 
                    "updated_at": null, 
                    "brand_id": 0                  

                }
            }
        },
        deleteReport: function(){
            var self = this;
            self.$api.deleteReport(self.report).then((response)=>{
                    if(response) {
                        console.log(response)
                        self.$emit('update_pool', self.report, "report", "delete");
                        self.new_report = false;
                        self.report = null;
                        self.report_record = null;
                        self.report_search = null;
                    }
                });

            

            
        },
        init: function(){
            this.filterReports();
            
        },
        label: function(key){
            return this.$Localization.str(key);
        },
        objLabel: function(obj,key){
            return this.$Localization.objStr(obj,key);
        },
        filterReports: function() {
            var self = this;
            clearTimeout(self.timer);
            self.timer = setTimeout(function(){
                var list = [];
                if(self.report_search!=null){
                    for(let i=0; i<self.list_reports.length; i++){
                        let report = self.list_reports[i];
                        if(report.name!=null && (self.objLabel(report, 'name').toLowerCase().includes(self.report_search.toLowerCase()) || report.code.toLowerCase().includes(self.report_search.toLowerCase())  )){    
                            list.push(report)
                        }
                    }
                }else{
                    list = self.list_reports;
                }
                self.filtered_reports = list;
            },100);
        },
        saveReport: function(){
            // To implement: Commented code
            var self = this;
            if(this.new_report) {
                self.$api.createReport(self.report).then((reportInfo)=>{
                    console.log(reportInfo)
                    if(reportInfo) {
                        self.report = reportInfo;
                        self.$emit('update_pool',self.report, "report", "create");
                        self.new_report = false;
                        self.report_record = self.report;
                    }
                });
            }
            else {
                self.$api.updateReportInfo(self.report).then((response)=>{
                    if(response) {
                        console.log(response)
                        self.report.updated_at = response.updated_datetime
                        self.$emit('update_pool',self.report, "report", "update");
                    }
                });
            }
        }
    },
    computed: {
        valid_report: function(){
            if(this.report===null){
                return false;
            }else{
                var report = this.report;
                var testResults = {
                    name: notEmpty(report.name),
                    code: notEmpty(report.code),
                    name_fr: notEmpty(report.name_fr),
                    source: notEmpty(report.source),
                    retentionPeriod: notEmpty(report.retentionPeriod),
                    report_type_id: notZero(report.report_type_id),
                    report_category_id: notZero(report.report_category_id),
                    report_frequency_id: notZero(report.report_frequency_id),
                    brand_id: notZero(report.brand_id)

                }
                return allTrue(testResults);
            }

            function notZero(value){
                return value!=0;
            }

            function notEmpty(value){
                return value!=null && value.toString().length>0;
            }

            function allTrue(obj){
                for(var key in obj){
                    if(obj[key]!=true){
                        return false;
                    }
                }

                return true;
            }
        },
        list_reports: function(){
            return this.adminData.userAdmin.report_metadata;
        },
        list_report_types: function(){          
            var report_Type_list = []
            var category_id =  this.report_category;
            if( this.report_category === 0) {  
                if(this.report.report_type_id){
                    for(let i =0 ; i < this.adminData.userAdmin.report_types.length; i++){
                        if(this.adminData.userAdmin.report_types[i].id === this.report.report_type_id){
                        category_id = this.adminData.userAdmin.report_types[i].report_category_id;
                        break;
                        }
                    }  
                }                        
            }
            if(category_id === 0) {
              report_Type_list = this.adminData.userAdmin.report_types;
            }else{
                for(let i=0; i < this.adminData.userAdmin.report_types.length; i++){
                    if(this.adminData.userAdmin.report_types[i].report_category_id === category_id){
                        report_Type_list.push(this.adminData.userAdmin.report_types[i])
                    }
                }
            }         
            return report_Type_list;
        },
        list_report_categories: function(){
            return this.adminData.userAdmin.report_categories;
        },
        list_report_frequencies: function(){
            return this.adminData.userAdmin.report_frequencies;
        },
        list_brands: function(){
            return this.adminData.userAdmin.brands;
        },
        get_report_category_id: function(){
            var category_id = 0;
            if(this.report.report_type_id){
                for(let i =0 ; i < this.adminData.userAdmin.report_types.length; i++){
                    if(this.adminData.userAdmin.report_types[i].id === this.report.report_type_id){
                    category_id = this.adminData.userAdmin.report_types[i].report_category_id;
                    break;
                    }
                }  
            }         
            return category_id;
        }
    },
    mounted: function(){
        this.init();
    },
    watch: {
        report_record: function(){
            var self = this;            
            
            if(self.report_record){
                let response = self.list_reports.find(element => element.code===this.report_record.code);
                self.new_report = false;
                self.report = response;
            }
        },
        report_search: function(){
            this.filterReports();          
        }
    },
    filters:{
        prettify_date: function (value) {
            return new Date(value).toLocaleString("en-US");
        }
    }
}
</script>

<style>

.box_radio{
    border-radius: 3px;
    padding: 5px;
    display: inline-block;
    margin-right: 5px;
    cursor: pointer;
}

.box_radio:hover{
    text-decoration: underline;
}

.box_radio input{
    display: none;
}

.lexus .themed{
    background-color: $lexus;
}
.lexus label.box_radio {
    border: 1px solid lightslategray;
    background-color: lightslategray;
    color: white;
}
.lexus label.box_radio.primary {
    background-color: $lexus;
    border-color: $lexus;
}

.toyota .themed{
    background-color: $toyota;
}
.toyota label.box_radio {
    border: 1px solid lightslategray;
    background-color: lightslategray;
    color: white;
}
.toyota label.box_radio.primary {
    background-color: $toyota;
    border-color: $toyota;
}

</style>

<style module>

    .selectReport{
    position: relative;
    display: inline-block;
    vertical-align: top;
    text-align: left;
    width: 45%;
    min-width: 250px;
    min-height: 200px;
    padding-top: 20px;
    /* border: 1px solid grey; */
    }
    .selectReport input {
    font-size: 1em;
    margin-bottom: 5px;
    padding: 3px;
    box-sizing: border-box;
    
    } 

.main{
    position: relative;
    display: inline-block;
    vertical-align: top;
    min-height: 400px;
    text-align: left;
    padding: 15px;
}

.main fieldset{
    position: relative;
    padding: 3px;
    margin-bottom: 12%;
}

.main ul{
    list-style: none;
    margin-left: 0px;
}

.main ul{
    margin-left: -15px;
}
.main li{
    margin-left: -20px;
    padding-left: 5px;
    border-radius: 2px;
}
.main li:hover{
    text-decoration: underline;
}
.main li:nth-child(odd){
    background-color: whitesmoke;
}

.main input[type='checkbox']{
    width: 15px;
    height: 15px;
    margin: 5px;
    transform: translateY(3px);

}

.formContent{
    width: 50%;
}

.formItem{
    display: block;
    margin: 10px;
    /*border-bottom: 1px solid whitesmoke;*/
    padding-bottom: 3px;
    margin-bottom: 5px;
    font-size: 0.8em;
}

.formItem input[type="text"]{
    font-size: 1em;
    min-width:225px;
}
.formItem input[type="number"]{
    font-size: 1em;
    min-width:200px;
}

.main_label{
    display: inline-block;
    /*min-width: 110px;*/
    font-size: 1em;
    font-weight: bold;    
}

.report_code{
    font-size: 0.75em;
    font-weight: normal;
    color: #a71414;
    display: inline-block;
    vertical-align: middle;
}

.report_name{
    font-size: 0.9em;
}
.selectReport tr{
}
.selectReport td{
    padding: 0;
    font-size:0.9em;
    white-space: nowrap;
    
}
.selectReport label{
    vertical-align: middle;
    /*font-size:0.9em;*/

}
.selectReport tr:nth-child(even){
        background-color: whitesmoke;
        
        
    }

.scrollTable{
    overflow:scroll;
    max-height: 500px;
    border: 2px solid whitesmoke; 
    border-radius: 5px;
}

.selectReport input[type="radio"]{
   vertical-align: middle;
   transform: translateY(7%);
}


.selectReport td{
    width: 90%;
}
.selectReport td:hover{
    text-decoration: underline;
}
  
</style>